import { gql, useMutation, useQuery } from "@apollo/client";

// ── GraphQL Documents ─────────────────────────────────────

export const GET_SESSION_SETTINGS = gql`
  query SessionSettings {
    sessionSettings {
      phoneNoticeText
      phoneNoticeAudioUrl
      phoneNoticeAudioKey
    }
  }
`;

export const UPDATE_SESSION_SETTINGS = gql`
  mutation UpdateSessionSettings($input: SessionSettingsInput!) {
    updateSessionSettings(input: $input) {
      phoneNoticeText
      phoneNoticeAudioUrl
      phoneNoticeAudioKey
    }
  }
`;

// ── TypeScript types ─────────────────────────────────────

export interface SessionSettingsData {
  sessionSettings: {
    phoneNoticeText: string | null;
    phoneNoticeAudioUrl: string | null;
    phoneNoticeAudioKey: string | null;
  } | null;
}

export interface SessionSettingsInput {
  phoneNoticeText?: string | null;
  phoneNoticeAudioUrl?: string | null;
  phoneNoticeAudioKey?: string | null;
}

export interface UpdateSessionSettingsVariables {
  input: SessionSettingsInput;
}

export interface UpdateSessionSettingsData {
  updateSessionSettings: {
    phoneNoticeText: string | null;
    phoneNoticeAudioUrl: string | null;
    phoneNoticeAudioKey: string | null;
  } | null;
}

// ── React hooks ─────────────────────────────────────

export function useSessionSettingsQuery() {
  return useQuery<SessionSettingsData>(GET_SESSION_SETTINGS);
}

export function useUpdateSessionSettingsMutation() {
  return useMutation<UpdateSessionSettingsData, UpdateSessionSettingsVariables>(
    UPDATE_SESSION_SETTINGS,
    {
      // The SessionSettings type has no `id`, so Apollo can't normalize the
      // mutation result into the `sessionSettings` query automatically. Write
      // it back by hand so every consumer re-renders with the change.
      update(cache, { data }) {
        if (!data?.updateSessionSettings) return;
        cache.writeQuery<SessionSettingsData>({
          query: GET_SESSION_SETTINGS,
          data: { sessionSettings: data.updateSessionSettings },
        });
      },
    },
  );
}
